import script from "./ALoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ALoader.vue?vue&type=script&setup=true&lang=js"

import "./ALoader.vue?vue&type=style&index=0&id=e05dec12&scoped=true&lang=css"

import exportComponent from "/opt/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e05dec12"]])

export default __exports__